<template>
    <div>
        <div class="air__utils__heading">
            <h5>Produto</h5>
        </div>
        <div class="card">
            <div class="card-body">
                <ProductForm button-text="Salvar" v-if="!isLoading" :data="productData" @saved="saveProduct"></ProductForm>
            </div>
        </div>
    </div>
</template>

<script>
import ProductForm from '../shared/ProductForm'
import { updateProduct, getProduct } from '@/services/product'
import store from '@/store'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['token']),
  },
  components: {
    ProductForm,
  },
  data() {
    return {
      productData: {},
      isLoading: true,
    }
  },
  async mounted() {
    const { data } = await getProduct(this.$route.params.id, this.token);
    this.productData = data
    this.isLoading = false
  },
  methods: {
    setLoadingState(state) {
      store.commit('UPDATE_LOADING_STATE', { active: state })
    },
    saveProduct: function(formData) {
      this.setLoadingState(true)
      updateProduct(this.$route.params.id, formData, this.token)
        .then(response => response.data)
        .then(() => {
          this.setLoadingState(false)
          this.$router.push('/ecommerce/product')
        })
        .catch((err) => {
          console.error(err)
          this.setLoadingState(false)
        })
    },
  },
}
</script>

<style scoped>

</style>
